import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './modules/angular-material.module';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { PlateSearchComponent } from './components/plate-search/plate-search.component';
import { HomeComponent } from './components/home/home.component';
import { CdkTableModule } from '@angular/cdk/table';
import { TableWizardComponent } from './components/table-wizard/table-wizard.component';
import { VehicleLabelComponent } from './components/vehicle-label/vehicle-label.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TableVersionsComponent } from './components/table-versions/table-versions.component';
import { VehicleIdentityComponent } from './components/vehicle-identity/vehicle-identity.component';
import { LoaderService } from './services/loader.service';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { ReportService } from './services/report.service';


@NgModule({
  declarations: [
    AppComponent,
    ToolbarComponent,
    PlateSearchComponent,
    HomeComponent,
    TableWizardComponent,
    VehicleLabelComponent,
    TableVersionsComponent,
    VehicleIdentityComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    FormsModule,
    CdkTableModule,
    HttpClientModule
  ],
  providers: [
    LoaderService,
    ReportService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
